import { Component, OnInit } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { ConfigService } from '../core/services/config.service';
import { Observable, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthService } from '../core/auth/auth.service';

@Component({
  selector: 'dx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  hasError$ = new Subject<boolean>();
  error: any;
  isUserActive: boolean | null=null;
  constructor(
    public authService:AuthService,public auth0Service: Auth0Service,
    private configService: ConfigService
  ) {}

  get hasReports(): boolean {
    return this.configService.hasLossRun;
  }

ngOnInit(): void {
    const tenant = this.configService.config?.tenantDomain;
    if (tenant?.includes('ric')) {
      this.auth0Service.isAuthenticated$.pipe(
        filter(isAuth => isAuth === true),
        take(1)
      ).subscribe(() => {
        this.configService.getUserStatus().pipe(take(1)).subscribe({
          next: (status) => {
            this.isUserActive = status;
          },
          error: () => {
            this.isUserActive = false;
          }
        });
      });
    } else {
      this.isUserActive = true;
    }
  }

}
